import { PortalBPSubMenuList } from '../list';

export class ListView extends PortalBPSubMenuList {
  name = 'list-view';
}